import zhLocale from "element-ui/lib/locale/lang/zh-CN";
export default {
  message: {
    hello: "你好，世界",
  },
  zhLocale,
};
